import GlobalAxios from "../axios/axios-config";
import {
  INewTopMedScheduleParams,
  ITopMedSchedulesParams,
} from "../models/topmed";

const TOPMED_SCHEDULE_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/TopMed/ElectiveAppointments/";

export const topmedScheduleRegisterPerson = (beneficiaryId: string) => {
  return GlobalAxios.post(TOPMED_SCHEDULE_ROUTE + "RegisterPerson", {
    beneficiaryId,
  });
};

export const topmedSchedules = (params: ITopMedSchedulesParams) => {
  return GlobalAxios.get(TOPMED_SCHEDULE_ROUTE + "ListAppointments", {
    params,
  });
};

export const saveTopMedSchedule = (params: INewTopMedScheduleParams) => {
  return GlobalAxios.post(
    TOPMED_SCHEDULE_ROUTE + "ScheduleAppointment",
    params
  );
};

export const cancelTopMedSchedule = (hash: string) => {
  return GlobalAxios.post(TOPMED_SCHEDULE_ROUTE + "CancelAppointment", {
    hash,
  });
};
